// import React from "react";
// import "@/App.css";
// import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
// import { AuthProvider, useAuth } from "@/lib/auth";
// import { Toaster } from "sonner";

// import Landing from "@/pages/Landing";
// import AuthCallback from "@/pages/AuthCallback";
// import Onboarding from "@/pages/Onboarding";
// import Dashboard from "@/pages/Dashboard";
// import Explore from "@/pages/Explore";
// import HowItWorks from "@/pages/HowItWorks";
// import ProfileDetail from "@/pages/ProfileDetail";
// import OpportunityDetail from "@/pages/OpportunityDetail";
// import CreateOpportunity from "@/pages/CreateOpportunity";
// import Applications from "@/pages/Applications";
// import MyProfiles from "@/pages/MyProfiles";
// import AddProfile from "@/pages/AddProfile";
// import EditProfile from "@/pages/EditProfile";
// import Settings from "@/pages/Settings";
// import MyGigs from "@/pages/MyGigs";
// import NotFound from "@/pages/NotFound";

// function Protected({ children }) {
//   const { account, loading } = useAuth();
//   const location = useLocation();
//   if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
//   if (!account) return <Navigate to="/" replace state={{ from: location }} />;
//   if (!account.onboarding_complete && location.pathname !== "/onboarding") {
//     return <Navigate to="/onboarding" replace />;
//   }
//   return children;
// }

// function AppRouter() {
//   const location = useLocation();
//   if (location.hash?.includes("session_id=")) return <AuthCallback />;
//   return (
//     <Routes>
//       <Route path="/" element={<Landing />} />
//       <Route path="/auth/callback" element={<AuthCallback />} />
//       <Route path="/how-it-works" element={<HowItWorks />} />
//       <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
//       <Route path="/explore" element={<Protected><Explore /></Protected>} />
//       <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
//       <Route path="/my-gigs" element={<Protected><MyGigs /></Protected>} />         
//       <Route path="/opportunities/:id" element={<Protected><OpportunityDetail /></Protected>} />
//       <Route path="/opportunities/new" element={<Protected><CreateOpportunity /></Protected>} />
//       <Route path="/opportunities/:id/edit" element={<Protected><CreateOpportunity /></Protected>} />
//       <Route path="/applications" element={<Protected><Applications /></Protected>} />
//       <Route path="/profiles" element={<Protected><MyProfiles /></Protected>} />
//       <Route path="/profiles/add" element={<Protected><AddProfile /></Protected>} />
//       <Route path="/profiles/view/:id" element={<Protected><ProfileDetail /></Protected>} />
//       <Route path="/profiles/:id/edit" element={<Protected><EditProfile /></Protected>} />
//       <Route path="/settings" element={<Protected><Settings /></Protected>} />
//       <Route path="*" element={<NotFound />} />
//     </Routes>
//   );
// }

// export default function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <AuthProvider>
//           <AppRouter />
//           <Toaster position="top-right" richColors />
//         </AuthProvider>
//       </BrowserRouter>
//     </div>
//   );
// }







import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster, toast } from "sonner";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Explore from "@/pages/Explore";
import HowItWorks from "@/pages/HowItWorks";
import ProfileDetail from "@/pages/ProfileDetail";
import OpportunityDetail from "@/pages/OpportunityDetail";
import CreateOpportunity from "@/pages/CreateOpportunity";
import Applications from "@/pages/Applications";
import MyProfiles from "@/pages/MyProfiles";
import AddProfile from "@/pages/AddProfile";
import EditProfile from "@/pages/EditProfile";
import Settings from "@/pages/Settings";
import MyGigs from "@/pages/MyGigs";
import Notifications from "@/pages/Notifications";
import NotFound from "@/pages/NotFound";

function Protected({ children }) {
  const { account, loading } = useAuth();
  const location = useLocation();
  useEffect(() => {
    if (!loading && !account && location.pathname.startsWith("/profiles/view/")) {
      toast.info("To explore more, please sign up or log in if you already have an account.");
    }
  }, [account, loading, location.pathname]);

  if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!account) return <Navigate to="/" replace state={{ from: location, loginRequired: location.pathname.startsWith("/profiles/view/") }} />;
  if (!account.onboarding_complete && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/my-gigs" element={<Protected><MyGigs /></Protected>} />
      <Route path="/opportunities/:id" element={<Protected><OpportunityDetail /></Protected>} />
      <Route path="/opportunities/new" element={<Protected><CreateOpportunity /></Protected>} />
      <Route path="/opportunities/:id/edit" element={<Protected><CreateOpportunity /></Protected>} />
      <Route path="/applications" element={<Protected><Applications /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/profiles" element={<Protected><MyProfiles /></Protected>} />
      <Route path="/profiles/add" element={<Protected><AddProfile /></Protected>} />
      <Route path="/profiles/view/:id" element={<Protected><ProfileDetail /></Protected>} />
      <Route path="/profiles/:id/edit" element={<Protected><EditProfile /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}